// extracted by mini-css-extract-plugin
export var callCard = "_rq-0";
export var callMessageButton = "_rq-1";
export var helpIcon = "_rq-3";
export var helpIconContainer = "_rq-4";
export var verticalDivider = "_rq-2";